export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    DEVICE_RECHARGE_ALL: function DEVICE_RECHARGE_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/device-recharge/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    DEVICE_RECHARGE_CREATE: function DEVICE_RECHARGE_CREATE(data) {
      return request({
        url: '/api/device-recharge/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_RECHARGE_DETAIL: function DEVICE_RECHARGE_DETAIL(id) {
      return request({
        url: '/api/device-recharge/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_RECHARGE_UPDATE: function DEVICE_RECHARGE_UPDATE(data) {
      return request({
        url: '/api/device-recharge/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    DEVICE_RECHARGE_DELETE: function DEVICE_RECHARGE_DELETE(id) {
      return request({
        url: '/api/device-recharge/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});